// Baked-in lender branding, mirroring cpcore's lender.defaults. Used as a
// synchronous fallback so the UI always renders, even before (or without) the
// /public/lender-config fetch. The backend config overlays these at runtime,
// so admin edits in cpbase take effect without a redeploy.

export const DEFAULT_PRIMARY_LENDER = "FEXPRIME";

export const DEFAULT_LENDER_PROFILES = {
  FEXPRIME: {
    key: "FEXPRIME",
    legalName: "Fexprime Finance Pvt. Ltd.",
    shortCode: "FFPL",
    productUrl: "https://www.fexprime.com/Personal-LoanRent-Financing",
    termsUrl: "https://fexprime.com/terms-service-aa",
    homeUrl: "https://fexprime.com",
    logoUrl: "/fp_logo_.png",
    enabled: true,
  },
  FINTREE: {
    key: "FINTREE",
    legalName: "Fintree Finance Pvt. Ltd.",
    shortCode: "FTFPL",
    productUrl: "https://fintreefinance.com/Personal-LoanRent-Financing",
    termsUrl: "https://fintreefinance.com/terms-service-aa",
    homeUrl: "https://fintreefinance.com/",
    logoUrl: "/fintree.png",
    enabled: true,
  },
  // Third lender, on the GLAAS/Finezza LOS. Mirrors cpcore's lender.defaults.ts.
  //
  // Identity confirmed by Gromor 2026-09-02. Never guess any of these: legalName and
  // shortCode are interpolated straight into consent sentences by buildConsents.
  //
  // productUrl / termsUrl are STILL AWAITED, and are not decorative — they are the
  // hrefs behind "PRODUCT DETAILS" and "AA Terms of Service" in the FEXPRIME banking
  // ConsentDialog. Blank renders href="", so that dialog must keep opening for
  // FEXPRIME journeys only (components/banking/bank_details) until both are filled in.
  // They do NOT gate the lender's identity: resolveLender resolves GROMOR to this
  // profile so "powered by" and consent copy name Gromor on a Gromor journey.
  GROMOR: {
    key: "GROMOR",
    legalName: "Gromor Finance Private Limited",
    shortCode: "GFPL",
    productUrl: "",
    termsUrl: "",
    homeUrl: "https://gromor.in/",
    logoUrl: "/gromor-finance.png",
    enabled: false,
  },
  // Fourth lender (lender4 design §1, §9; kit L26): NATIVE, without-banking only. Mirrors cpcore's
  // lender.defaults.ts. Identity from the Satya Capital lender kit (docs/lender4/_kit, 3 Oct 2026).
  // productUrl / termsUrl are still awaited from the lender — the home page stands in for both
  // until they arrive (lender4 P9 brief). `enabled: false` mirrors cpcore, which keeps a disabled
  // lender out of /public/lender-config; the neutral-copy rule (lenderResolveCore.js) still covers
  // any lender whose identity is blank.
  SATYA: {
    key: "SATYA",
    legalName: "Satya Capital Services Private Limited",
    shortCode: "Satya Capital",
    productUrl: "https://www.satyacapital.co.in/",
    termsUrl: "https://www.satyacapital.co.in/",
    homeUrl: "https://www.satyacapital.co.in/",
    logoUrl: "/satya-logo.png",
    enabled: false,
    // Ops 21 Oct 2026: Work Details hides "Self Employed" for now (mirrors cpcore; the live config wins).
    capabilities: {
      employment: { selfEmployedAllowed: true, workEmailRequired: false, hiddenEmploymentTypes: ["SELF_EMPLOYED"] },
    },
    limits: { exposureCapInr: 500000 },
  },
};
